// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__31Dd7","overflowing":"ReadFullNote_overflowing__36lTe"};